import { css } from 'linaria';

export const proportionalEmptyBanner = css`
  /* retail-rocket banner size for desktop: 1180px x 264px */
  aspect-ratio: 1180 / 264;
  width: 100%;

  @media (--only-mobile) {
    /* retail-rocket banner size for mobile: 264px x 330px, 377px - swiper width 100% */
    aspect-ratio: 377 / 330;
    width: 93vw;
  }
`;
